import ValidationType from '../ValidationType';
import { datesAreEqual } from "../../dateutil";
import moment from 'moment-timezone';

class EqualsTime extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    let current_raw;
    let compare_raw;
    let compare_print;
    if (!fieldResponse.isEmpty) {
      if (!moment(fieldResponse.currentValue).isValid()){
        current_raw = moment(fieldResponse.currentValue, 'h:mma').format('h:mma');
      }
      else if( moment(fieldResponse.currentValue,"YYYY-MM-DDTHH:mm:ss.SSSSZ").isValid()) {
        current_raw = moment(fieldResponse.currentValue,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset(moment(fieldResponse.currentValue,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset() ).format('h:mma');;
       
      }
      else{

        current_raw = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('h:mma');;
      }

      if (!moment(validation.value).isValid()){

        compare_raw = moment(validation.value, 'h:mma').format('h:mma');
        compare_print = moment(validation.value, 'h:mma').format('h:mma');
      }
      else if( moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSSZ").isValid()) {
        compare_raw = moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset(moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset() ).format('h:mma');
        compare_print = moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset(moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset() ).format('h:mma');
      
      }
      else{


        compare_raw = moment(validation.value).utcOffset(moment(validation.value).utcOffset() ).format('h:mma');
        compare_print = moment(validation.value).utcOffset(moment(validation.value).utcOffset() ).format('h:mma');
      }
      const compare =  moment(compare_raw, 'h:mma').format('YYYY-MM-DD HH:mm');
      const current =  moment(current_raw, 'h:mma').format('YYYY-MM-DD HH:mm');

      if (!datesAreEqual(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_EQUAL_TO_SPECIFIED_VALUE',
          values: { value: validation.value },
          message: `Value should be equal to '${compare_print}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default EqualsTime;
